import { Pipe, PipeTransform } from '@angular/core';
import { displayProviderOfficeFaxStatus } from 'app/core/options/provider-office-status.opts';

@Pipe({ name: 'providerOfficeFaxStatus' })
export class ProviderOfficeFaxStatusPipe implements PipeTransform {
  transform = displayProviderOfficeFaxStatus
}
